import React from "react";
import BiometricSetup from "../components/BiometricSetup";
import TotpSetup from "../components/TotpSetup";

const SecuritySettings = () => {
  return (
    <div style={{ padding: "30px", background: "#f8fafc", minHeight: "100vh" }}>
      <h2 style={{ fontSize: "28px", color: "#1e293b", fontWeight: "700", marginBottom: "20px" }}>
        Security Settings
      </h2>
      <BiometricSetup />
       <TotpSetup />
    </div>
  );
};

export default SecuritySettings;